exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".baner-carousel .hooper{height:auto}.baner-carousel .hooper .hooper-track{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.baner-carousel .hooper .hooper-next{right:-35px;-webkit-filter:brightness(0) invert(1);filter:brightness(0) invert(1)}.baner-carousel .hooper .hooper-prev{left:-35px;-webkit-filter:brightness(0) invert(1);filter:brightness(0) invert(1)}\n", ""]);

// exports
